<template>
  <div class="header-actions">
    <div class="like-btn">
      <span>您好，{{ userNickname || username || '用户' }}</span>
    </div>
    <el-tooltip class="item" effect="dark" content="资产库" placement="top">
      <i v-if="!isAssetsPage" class="iconfont icon-zichanku1 tab-icon" @click.stop="goToAssets"></i>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" content="首页" placement="top">
      <i class="iconfont icon-shouye3 tab-icon" @click.stop="goHome"></i>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" :content="`可用积分：${userPoints}`" placement="top">
      <div class="user-points-wrap">
          <img style="width: 12px;" src="@/assets/image/jifen.png" alt=""><span style="color: #000">{{ formatPoints(userPoints) }}</span>
      </div>
    </el-tooltip>
    <div class="avatar-wrap" @click.stop="toggleDropdown">
      <img v-if="userAvatar" :src="userAvatar" class="avatar-img" alt="avatar" />
      <i v-else class="el-icon-user-solid avatar-icon"></i>
      <div v-if="dropdownVisible" class="avatar-dropdown">
        <!-- 用户信息头部 -->
        <div class="dropdown-user-header">
          <img v-if="userAvatar" :src="userAvatar" class="dropdown-avatar" alt="avatar" />
          <i v-else class="el-icon-user-solid dropdown-avatar-icon"></i>
          <div class="dropdown-user-info">
            <div class="dropdown-user-name">
              <span>{{ userNickname || username || '用户' }}</span>
              <span class="dropdown-points-badge">
                <img src="@/assets/image/jifen.png" alt="" class="dropdown-points-icon" />
                {{ formatPoints(userPoints) }}
              </span>
            </div>
            <div class="dropdown-user-account">账号名  {{ username || '--' }}</div>
          </div>
        </div>
        <!-- 菜单项 -->
        <div class="dropdown-menu-list">
          <div class="dropdown-item" @click.stop="openBatchManager">
            <i class="iconfont icon-jujironghe"></i>
            <span>管理剧集</span>
            <span v-if="activeBatchCount > 0" class="batch-badge">{{ activeBatchCount }}</span>
          </div>
          <div class="dropdown-item" @click.stop="openHistory">
            <i class="iconfont icon-lishijilu"></i>
            <span>打开历史</span>
          </div>
          <div class="dropdown-item" @click.stop="goToProfile">
            <i class="iconfont icon-gerenzhongxin"></i>
            <span>个人中心</span>
          </div>
          <div class="dropdown-item" @click.stop="goToTimbre">
            <i class="iconfont icon-fanyipeiyin"></i>
            <span>音色库</span>
          </div>
          <div class="dropdown-item" @click.stop="openAgreement">
            <i class="el-icon-document-checked"></i>
            <span>AI功能使用规范</span>
          </div>
          <div class="dropdown-item dropdown-item-logout" @click.stop="handleLogout">
            <i class="iconfont icon-tuichu1"></i>
            <span>退出登录</span>
            <i class="el-icon-arrow-right dropdown-item-arrow"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- 剧集管理弹窗 -->
    <div v-if="batchManagerVisible" class="history-overlay" @click.self="batchManagerVisible = false">
      <div class="history-modal batch-manager-modal">
        <div class="history-header">
          <span class="history-title">管理剧集</span>
          <i class="el-icon-close history-close" @click="batchManagerVisible = false"></i>
        </div>
        <div class="history-body">
          <div v-if="batchTaskList.length === 0" class="history-empty">暂无分批任务</div>
          <div
            v-for="task in batchTaskList"
            :key="task.scriptId"
            class="history-item batch-task-item"
            @click="goToBatchWorkbench(task)"
          >
            <i class="el-icon-film batch-task-icon"></i>
            <div class="history-item-info">
              <span class="history-item-title">{{ task.scriptName || '未命名剧本' }}</span>
              <span class="history-item-meta">
                <span class="batch-task-progress">
                  {{ getBatchDone(task) }}/{{ (task.batches || []).length }}集完成
                </span>
                <span v-if="getBatchFailed(task) > 0" class="batch-task-failed">
                  · {{ getBatchFailed(task) }}集失败
                </span>
                <span v-if="getBatchRunning(task) > 0" class="batch-task-running">
                  · <i class="el-icon-loading"></i> 运行中
                </span>
                <span class="history-item-time">{{ formatTime(task.updatedAt) }}</span>
              </span>
            </div>
            <div class="batch-task-actions" @click.stop>
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                circle
                @click="deleteBatchTaskItem(task)"
              ></el-button>
            </div>
            <i class="el-icon-arrow-right history-item-arrow"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- AI功能使用规范弹窗 -->
    <AgreementDialog :visible.sync="agreementVisible" />

    <!-- 历史记录弹窗 -->
    <div v-if="historyVisible" class="history-overlay" @click.self="historyVisible = false">
      <div class="history-modal">
        <div class="history-header">
          <span class="history-title">打开历史</span>
          <i class="el-icon-close history-close" @click="historyVisible = false"></i>
        </div>
        <div class="history-body">
          <div v-if="historyList.length === 0" class="history-empty">暂无历史记录</div>
          <div
            v-for="item in historyList"
            :key="item.id"
            class="history-item"
            @click="goToProject(item)"
          >
            <i class="el-icon-document history-item-icon"></i>
            <div class="history-item-info">
              <span class="history-item-title">{{ item.title }}</span>
              <span class="history-item-meta">
                <span class="history-item-id">ID: {{ item.id }}</span>
                <span class="history-item-time">{{ formatTime(item.openedAt) }}</span>
              </span>
            </div>
            <i class="el-icon-arrow-right history-item-arrow"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clearAuthState, getUserProfile, setUserProfile } from '@/utils/auth'
import { getCurrentUser } from '@/api/c/auth'
import { TASK_STORAGE_PREFIX, BATCH_STATUS, deleteBatchTask } from '@/utils/batchReasoningTask'
import AgreementDialog from './AgreementDialog.vue'

export default {
  name: 'HeaderActions',
  components: { AgreementDialog },
  props: {
    likeCount: {
      type: Number,
      default: 68
    }
  },
  data() {
    return {
      dropdownVisible: false,
      username: getUserProfile()?.username || '',
      userNickname: getUserProfile()?.nickname || '',
      userAvatar: getUserProfile()?.avatar || '',
      userPoints: getUserProfile()?.points !== undefined ? getUserProfile().points : null,
      historyVisible: false,
      historyList: [],
      batchManagerVisible: false,
      batchTaskList: [],
      activeBatchCount: 0,
      agreementVisible: false,
    }
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown)
    this.refreshBadge()
    this._badgeTimer = setInterval(this.refreshBadge, 5000)
    this.$root.$on('user-profile-updated', this.onUserProfileUpdated)
    // this.fetchUserPoints()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown)
    if (this._badgeTimer) clearInterval(this._badgeTimer)
    this.$root.$off('user-profile-updated', this.onUserProfileUpdated)
  },
  computed: {
    isAssetsPage() {
      const p = this.$route && this.$route.path
      return p === '/xiaoyunque/myAssets' || p === '/xiaoyunque/index'
    },
  },
  methods: {
    onUserProfileUpdated(userInfo) {
      if (!userInfo) return
      this.userNickname = userInfo.nickname || this.userNickname
      this.userAvatar = userInfo.avatar || this.userAvatar
      if (userInfo.points !== undefined) this.userPoints = userInfo.points
    },
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible
      if (this.dropdownVisible) this.refreshBadge()
    },
    closeDropdown() {
      this.dropdownVisible = false
    },
    goToAssets() {
      this.dropdownVisible = false
      const id = this.$route && this.$route.query && this.$route.query.id
      const query = id ? { id } : {}
      this.$router.push({ path: '/xiaoyunque/myAssets', query })
    },
    goHome() {
      this.dropdownVisible = false
      if (this.$route.path !== '/xiaoyunque/index') {
        this.$router.push('/xiaoyunque/index')
      }
    },
    goToProfile() {
      this.dropdownVisible = false
      this.$router.push('/user/profile')
    },
    goToTimbre() {
      this.dropdownVisible = false
      this.$router.push('/xiaoyunque/timbre/timbreList')
    },
    openAgreement() {
      this.dropdownVisible = false
      this.agreementVisible = true
    },
    handleLogout() {
      this.dropdownVisible = false
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearAuthState()
        this.$router.push('/login')
      }).catch(() => {})
    },
    openHistory() {
      this.dropdownVisible = false
      try {
        this.historyList = JSON.parse(localStorage.getItem('project_open_history') || '[]')
      } catch (e) {
        this.historyList = []
      }
      this.historyVisible = true
    },
    goToProject(item) {
      this.historyVisible = false
      try {
        const KEY = 'project_open_history'
        const list = JSON.parse(localStorage.getItem(KEY) || '[]')
        const filtered = list.filter(i => i.id !== item.id)
        filtered.unshift({ id: item.id, title: item.title, openedAt: Date.now() })
        localStorage.setItem(KEY, JSON.stringify(filtered.slice(0, 50)))
      } catch (e) {}
      this.$router.push(`/xiaoyunque/detail/script?id=${item.id}`)
    },

    // ===== 剧集管理 =====
    refreshBadge() {
      this.activeBatchCount = this.scanBatchTasks().length
    },
    openBatchManager() {
      this.dropdownVisible = false
      this.batchTaskList = this.scanBatchTasks()
      this.batchManagerVisible = true
    },
    scanBatchTasks() {
      const list = []
      try {
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i)
          if (key && key.indexOf(TASK_STORAGE_PREFIX) === 0) {
            try {
              const task = JSON.parse(localStorage.getItem(key))
              if (task && task.scriptId) list.push(task)
            } catch (e) {}
          }
        }
      } catch (e) {}
      return list.sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0))
    },
    getBatchDone(task) {
      return (task.batches || []).filter(b => b.status === BATCH_STATUS.DONE).length
    },
    getBatchFailed(task) {
      return (task.batches || []).filter(b => b.status === BATCH_STATUS.FAILED).length
    },
    getBatchRunning(task) {
      return (task.batches || []).filter(b => b.status === BATCH_STATUS.RUNNING).length
    },
    goToBatchWorkbench(task) {
      this.batchManagerVisible = false
      const target = {
        path: '/xiaoyunque/detail/script',
        query: { id: String(task.scriptId), openWorkbench: '1' }
      }
      if (this.$route.path === target.path && this.$route.query.id === String(task.scriptId)) {
        this.$root.$emit('open-batch-workbench', task.scriptId)
      } else {
        this.$router.push(target)
      }
    },
    deleteBatchTaskItem(task) {
      this.$confirm('确定删除该剧集任务？已写入数据库的分镜不会被删除。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteBatchTask(task.scriptId)
        this.batchTaskList = this.scanBatchTasks()
        this.refreshBadge()
        this.$message.success('已删除')
      }).catch(() => {})
    },

    formatTime(ts) {
      const d = new Date(ts)
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    fetchUserPoints() {
      getCurrentUser().then(res => {
        if (res && res.data) {
          const user = res.data
          if (user.points !== undefined) this.userPoints = user.points
          // 同步更新本地缓存
          const profile = getUserProfile() || {}
          setUserProfile({ ...profile, ...user })
        }
      })
    },
    formatPoints(points) {
      if (points === null || points === undefined) return '--'
      const num = Number(points)
      if (isNaN(num)) return '--'
      if (num >= 10000) {
        return (num / 10000).toFixed(1) + 'w'
      }
      return num.toLocaleString('en-US')
    }
  }
}
</script>

<style scoped>
.user-points-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #e6a23c;
  font-weight: 500;
}
.user-points-wrap .iconfont {
  font-size: 14px;
}
.tab-icon{
  cursor: pointer;
  color:#7a848b;
}
.tab-icon:hover {
  color: #0E0D0D;
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 18px;
}

.like-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #555;
  cursor: pointer;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 4px 10px;
}

.like-btn:hover {
  background: #eeebff;
  border-color: #c5b4fd;
  color: #7c5cfc;
}
.home-btn{
  margin: 0;
  background: #fff !important;
  border-color: #7c5cfc !important;
  color: #7c5cfc !important;
  border-radius: 16px !important;
  padding: 5px 14px !important;
}

.assets-btn {
  border-color: #2bc8a3 !important;
  color: #2bc8a3 !important;
}

.action-icon {
  font-size: 18px;
  color: #888;
  cursor: pointer;
}

.action-icon:hover {
  color: #555;
}

.avatar-wrap {
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: visible;
}

.avatar-icon {
  font-size: 20px;
  color: #999;
}

.avatar-img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}

.avatar-dropdown {
  position: absolute;
  top: 38px;
  right: 0;
  min-width: 266px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 999;
}

.dropdown-user-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 16px 12px;
  border-bottom: 1px solid #f0f0f0;
}

.dropdown-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.dropdown-avatar-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #999;
  flex-shrink: 0;
}

.dropdown-user-info {
  flex: 1;
  min-width: 0;
}

.dropdown-user-name {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #222;
}

.dropdown-points-badge {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  font-weight: 500;
  padding: 1px 6px;
  padding-right: 0;
  color: #fd9724;
  border-radius: 10px;
}

.dropdown-points-icon {
  width: 12px;
  height: 12px;
}

.dropdown-user-account {
  font-size: 12px;
  color: #999;
  margin-top: 3px;
}

.dropdown-menu-list {
  padding: 6px 0;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  font-size: 14px;
  color: #7a848b;
  cursor: pointer;
  transition: background 0.2s;
}

.dropdown-item:hover {
  background: #f9f7ff;
  color: #7c5cfc;
}

.dropdown-item:hover i:first-child {
  color: #7c5cfc;
}

.dropdown-item i:first-child {
  font-size: 16px;
  color: #7a848b;
}

.dropdown-item-logout {
  position: relative;
}

.dropdown-item-arrow {
  margin-left: auto;
  font-size: 16px;
  color: #7a848b;
}

.batch-badge {
  background: #f56c6c;
  color: #fff;
  font-size: 10px;
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 8px;
  padding: 0 4px;
  margin-left: auto;
}

.history-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.history-modal {
  background: #fff;
  border-radius: 12px;
  width: 420px;
  max-width: 90vw;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.batch-manager-modal {
  width: 520px;
}

.history-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.history-title {
  font-size: 15px;
  font-weight: 600;
  color: #222;
}

.history-close {
  font-size: 16px;
  color: #999;
  cursor: pointer;
}

.history-close:hover {
  color: #555;
}

.history-body {
  overflow-y: auto;
  padding: 8px 0;
  max-height: 400px;
}

.history-empty {
  text-align: center;
  padding: 40px 0;
  color: #aaa;
  font-size: 13px;
}

.history-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  cursor: pointer;
  transition: background 0.15s;
}

.history-item:hover {
  background: #f5f7ff;
}

.history-item-icon {
  font-size: 18px;
  color: #7c5cfc;
  flex-shrink: 0;
}

.batch-task-icon {
  font-size: 20px;
  color: #3f6dee;
  flex-shrink: 0;
}

.history-item-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.history-item-title {
  font-size: 13px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.history-item-time {
  font-size: 11px;
  color: #aaa;
}

.history-item-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.history-item-id {
  font-size: 11px;
  color: #bbb;
  font-family: monospace;
}

.history-item-arrow {
  font-size: 12px;
  color: #ccc;
  flex-shrink: 0;
}

.batch-task-progress {
  font-size: 12px;
  color: #4ecdc4;
  font-weight: 500;
}

.batch-task-failed {
  font-size: 12px;
  color: #f56c6c;
}

.batch-task-running {
  font-size: 12px;
  color: #e6a23c;
}

.batch-task-actions {
  flex-shrink: 0;
}
</style>
